import {
  Autocomplete,
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  ListItem,
  ListItemText,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  InputAdornment,
  Tabs,
  Tab,
  DialogActions,
  Button,
  List,
  Container,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import useUserStore from "../../../services/userStore";
import axios from "axios";
import { NGROK } from "../../../APIs";
import { myLocalStorage } from "../../../components/StorageHelper";
import moment from "moment";
import GroupIcon from "@mui/icons-material/Group";
import PersonIcon from "@mui/icons-material/Person";
import SyncIcon from "@mui/icons-material/Sync";
import AzureGroupDetails from "./Components/AzureGroupDetails";
import AzureUserDetails from "./Components/AzureUserDetails";
import TailwinButton from "../../../tailwind-ui/components/TailwinButton";
import TailwindTable from "../../../tailwind-ui/components/TailwindTable";
import { FaUsers, FaUser } from "react-icons/fa";
import TailwindFilterHeader from "../../../tailwind-ui/components/TailwindFilterHeader";
import useCloudSyncStore from "../../../services/useCloudSyncStore";
import { triggerCloudSync } from "../../../triggerCloudSync";
import useNotificationStore from "../../../services/notificationStore";

const AzureGroups = () => {
  const [selectedTenantName, setSelectedTenantName] = useState(null);
  const userData = useUserStore((state) => state.user);
  const [tenantList, setTenantList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [azureGroups, setAzureGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedUsers, setSelectedUsers] = useState(null);
  const [usersLoading, setUsersLoading] = useState(false);
  const [azureusers, setAzureusers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchUsers, setSearchUsers] = useState("");
  const [selectedTab, setSelectedTab] = useState(0);
  const [isSyncing, setIsSyncing] = useState(false);
  const syncStatus = useCloudSyncStore((state) => state.syncStatus);
  let { azureConfig } = useNotificationStore.getState();
  const [subList, setSubList] = useState([]);
  const [selectedSubList, setSelectedSubList] = useState(null);
  const latestSubList =
    myLocalStorage.getItem("latestSubList")?.subscriptionName;
  const latestTenant = myLocalStorage.getItem("latestTenant")?.tenantName;

  const typographyHeaderStyles = {
    fontSize: "16px",
    display: "inline",
    fontWeight: 600,
  };

  const typographyBodyStyles = { fontSize: "16px", display: "inline" };

  const demandSync = async () => {
    try {
      const data = await triggerCloudSync(
        "azure",
        "/api/azure-sync/onDemand",
        selectedTenantName,
      );
      console.log("Azure Sync complete:", data);
    } catch (error) {
      console.error("Azure Sync failed", error);
    }
  };

  const handleTabChange = (event, newTab) => {
    setSelectedTab(newTab);
  };

  const handleUserRowClick = (users) => {
    setSelectedUsers(users);
  };

  const handleRowClick = (group) => {
    setSelectedUsers(null);
    setSelectedGroup(group);
    getUsersForTheGroup(group);
    setSearchUsers("");
  };

  const getUsersForTheGroup = async (group) => {
    setUsersLoading(true);
    try {
      const response = await axios.get(
        `${NGROK}/api/azure/v1/group-users?groupId=${group?.id}`,
      );
      if (response?.data) {
        setAzureusers(response?.data);
      }
    } catch (e) {
      console.error(e);
    }

    setUsersLoading(false);
  };

  const handleTenantChange = (value) => {
    const tenant = tenantList.find((tenant) => tenant.tenantName === value);
    if (tenant !== undefined) {
      setSelectedTenantName(tenant.tenantName);
      myLocalStorage.setItem("latestTenant", tenant);
    }
  };

  const fetchAzureGroups = async (isFirst = false) => {
    try {
      if (isFirst) {
        setLoading(true);
      }
      const response = await axios.get(
        `${NGROK}/api/azure/v1/groups?tenantName=${selectedTenantName}`,
      );
      if (response?.data) {
        if (isFirst) {
          setSelectedGroup(response?.data[0]);
          getUsersForTheGroup(response?.data[0]);
        }
        setAzureGroups(response?.data);
      }
    } catch (e) {}

    setLoading(false);
  };

  const handleSubscriptionChange = (value) => {
    const sub = subList.find((subs) => subs?.subscriptionName === value);
    if (sub !== undefined) {
      setSelectedSubList(sub);
      myLocalStorage.setItem("latestSubList", sub);
    }
  };

  const fetchSubList = async () => {
    try {
      const response = await axios.get(
        `${NGROK}/api/azureResources/v1/all?tenantName=${latestTenant}&type=SUBSCRIPTION`,
      );

      const subs = response?.data || [];
      setSubList(subs);

      if (subs.length > 0) {
        let latest = null;

        try {
          latest =
            typeof latestSubList === "string"
              ? JSON.parse(latestSubList)
              : latestSubList;
        } catch (e) {
          latest = null;
        }

        const match = latest
          ? subs.find(
              (item) => item?.subscriptionName === latest?.subscriptionName,
            )
          : null;

        const selected = match || subs[0];

        setSelectedSubList(selected);

        myLocalStorage.setItem("latestSubList", JSON.stringify(selected));
      } else {
        setSelectedSubList(null);
      }
    } catch (error) {
      console.error("Failed to fetch subscriptions:", error);
      setSubList([]);
      setSelectedSubList(null);
    }
  };

  useEffect(() => {
    if (tenantList.length === 1)
      return setSelectedTenantName(tenantList[0].tenantName);

    if (tenantList?.length > 1) {
      const latestTenantName =
        myLocalStorage.getItem("latestTenant")?.tenantName;

      const tenant = tenantList.find(
        (tenant) => tenant.tenantName === latestTenantName,
      );
      if (tenant) setSelectedTenantName(tenant.tenantName);
      else setSelectedTenantName(tenantList[0].tenantName);
    }
  }, [tenantList]);
  useEffect(() => {
    const fetchTenants = async () => {
      const response = await axios.get(`${NGROK}/api/get-all-domains`);
      setTenantList(response.data);
    };
    fetchTenants();
  }, [userData]);

  useEffect(() => {
    if (!selectedTenantName) return;
    fetchAzureGroups(true);
    const interval = setInterval(() => {
      fetchAzureGroups();
    }, 5000);
    return () => clearInterval(interval);
  }, [selectedTenantName]);

  useState(() => {
    fetchSubList();
  }, [selectedTenantName, latestTenant]);

  const filteredGroups = azureGroups.filter((group) =>
    group.displayName.toLowerCase().includes(searchTerm.toLowerCase()),
  );
  const filteredUsers = azureusers?.filter((user) =>
    user.displayName.toLowerCase().includes(searchUsers.toLowerCase()),
  );

  const renderCellDetails = (groups, colIndex) => {
    let groupsArray = groups;
    if (!Array.isArray(groups)) {
      groupsArray = [groups];
    }
    switch (colIndex) {
      case 0:
        return (
          <div className="flex flex-wrap gap-2">
            {groupsArray?.map((group) => (
              <div
                className="flex flex-row items-center cursor-pointer"
                onClick={() => handleRowClick(group)}
              >
                <div className="ml-2">
                  <p className="text-lg font-semibold">{group.displayName}</p>
                </div>
              </div>
            ))}
          </div>
        );

      default:
        return null;
    }
  };

  const renderUserDetailsInfo = (users, colIndex) => {
    let usersArray = users;
    if (!Array.isArray(users)) {
      usersArray = [users];
    }
    switch (colIndex) {
      case 0:
        return (
          <div className="flex flex-wrap gap-2">
            {usersArray?.map((user) => (
              <div
                className="flex flex-row items-center cursor-pointer"
                onClick={() => handleUserRowClick(user)}
              >
                <div className="ml-2">
                  <p className="text-lg font-semibold">{user.displayName}</p>
                </div>
              </div>
            ))}
          </div>
        );

      default:
        return null;
    }
  };

  const renderGroupDetails = (selectGroup, roleAction, azureusers) => {
    const filteredUsers =
      azureusers?.filter((user) =>
        user.displayName?.toLowerCase().includes(searchUsers.toLowerCase()),
      ) || [];

    const renderGroupDetails = (selectGroup) => (
      <div className="w-full">
        {selectGroup ? (
          <AzureGroupDetails group={selectGroup} />
        ) : (
          <div className="p-4 text-sm text-gray-500">No group selected</div>
        )}
      </div>
    );
    const renderUserDetails = (users) => (
      <TailwindTable
        columns={[""]}
        data={users}
        renderCell={renderUserDetailsInfo}
        isSelected={(user) => selectedUsers?.id === user?.id}
        searchFilter={true}
        searchAction={setSearchUsers}
        searchValue={searchUsers}
        needLoading={false}
        headerStyleNeeded={false}
      />
    );

    switch (roleAction) {
      case 0:
        return renderGroupDetails(selectGroup);
      case 1:
        return renderUserDetails(filteredUsers);
      default:
        return null;
    }
  };

  const renderRoleRulesDetailsCell = (
    selectedGroup,
    colIndex,
    col,
    azureusers,
  ) => {
    const tabs = [
      {
        label: "Groups",
        icon: <FaUsers className="mr-2" />,
        value: 0,
      },
      {
        label: `Users${azureusers?.length > 0 ? ` (${azureusers.length})` : ""}`,
        icon: <FaUser className="mr-2" />,
        value: 1,
      },
    ];
    switch (colIndex) {
      case 0:
        return (
          <>
            <div className="flex text-base font-medium border-b border-gray-300">
              {tabs.map((tab) => (
                <button
                  key={tab.value}
                  onClick={() => setSelectedTab(tab.value)}
                  className={`flex items-center px-4 py-2 transition-colors duration-200 ${
                    selectedTab === tab.value
                      ? "border-b-2 border-blue-600 text-blue-600"
                      : "text-gray-600 hover:text-blue-500"
                  }`}
                >
                  {tab.icon}
                  {tab.label}
                </button>
              ))}
            </div>
            {renderGroupDetails(selectedGroup, selectedTab, azureusers)}
          </>
        );
    }
  };
  const renderUserDetailsCell = (selectedUser, colIndex, col) => {
    switch (colIndex) {
      case 0:
        return (
          <div className="p-4">
            <AzureUserDetails user={selectedUser} />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <div className="p-4">
        <TailwindFilterHeader
          title="Azure Groups"
          isIconNeeded={true}
          subtitle={"Manage cloud groups and permissions"}
          dropdowns={[
            {
              label: "Tenant",
              value: selectedTenantName,
              options: tenantList.map((t) => ({
                label: t.tenantName,
                value: t.tenantName,
              })),
              onChange: handleTenantChange,
            },
            {
              label: "Subscription",
              value: selectedSubList?.subscriptionName,
              options: subList.map((t) => ({
                label: t?.subscriptionName,
                value: t?.subscriptionName,
              })),
              onChange: handleSubscriptionChange,
            },
          ]}
          tabs={[]}
          isSyncing={syncStatus["azure"]}
          onSync={demandSync}
          isSyncNeeded={azureConfig ? true : false}
        />
      </div>

      <div className="grid w-full grid-cols-3 gap-2">
        <div className="col-span-1">
          <TailwindTable
            columns={["Groups"]}
            data={filteredGroups}
            renderCell={renderCellDetails}
            isSelected={(group) => group.id === selectedGroup.id}
            searchFilter={true}
            searchAction={setSearchTerm}
            searchValue={searchTerm}
            needLoading={false}
          />
        </div>

        <div className="col-span-1">
          <TailwindTable
            columns={["Details"]}
            data={
              Array.isArray(selectedGroup) ? selectedGroup : [selectedGroup]
            }
            renderCell={(selectedGroup, colIndex, col) =>
              renderRoleRulesDetailsCell(
                selectedGroup,
                colIndex,
                col,
                azureusers,
              )
            }
            needLoading={false}
          />
        </div>
        {selectedUsers && (
          <div className="col-span-1">
            <TailwindTable
              columns={[`Details of ${selectedUsers?.displayName || "User"}`]}
              data={[selectedUsers]}
              renderCell={(selectedUser, colIndex, col) =>
                renderUserDetailsCell(selectedUser, colIndex, col)
              }
              needLoading={false}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default AzureGroups;
